import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-440b9d0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "page-title" }
const _hoisted_7 = { class: "last-update" }
const _hoisted_8 = {
  key: 0,
  class: "date-range-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "From", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "To", -1))
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KDatePicker = _resolveComponent("KDatePicker")!
  const _component_k_loader = _resolveComponent("k-loader")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_summary_tab = _resolveComponent("summary-tab")!
  const _component_revenue_and_commission_tab = _resolveComponent("revenue-and-commission-tab")!
  const _component_client_manager_breakdown_tab = _resolveComponent("client-manager-breakdown-tab")!
  const _component_client_manager_clients_tab = _resolveComponent("client-manager-clients-tab")!
  const _component_KTabStrip = _resolveComponent("KTabStrip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.pageTitle), 1),
            _createElementVNode("span", _hoisted_7, " (last updated on " + _toDisplayString(_ctx.lastUpdate) + ")", 1)
          ]),
          (_ctx.selectedTab !== 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _createVNode(_component_KDatePicker, {
                    format: 'yyyy-MM-dd',
                    value: _ctx.from,
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDatechange($event, 'from')))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_10,
                  _createVNode(_component_KDatePicker, {
                    format: 'yyyy-MM-dd',
                    value: _ctx.to,
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDatechange($event, 'to')))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_k_button, { onClick: _ctx.onApplyDateRange }, {
                    default: _withCtx(() => [
                      (!_ctx.isDataLoading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Apply"))
                        : (_openBlock(), _createBlock(_component_k_loader, {
                            key: 1,
                            size: 'medium',
                            type: 'pulsing'
                          }))
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_KTabStrip, {
            selected: _ctx.selectedTab,
            "tab-position": 'top',
            tabs: _ctx.tabs,
            onSelect: _ctx.onSelectTab
          }, {
            summary: _withCtx(() => [
              (_openBlock(), _createBlock(_component_summary_tab, _mergeProps({ key: _ctx.yearAndOptionKey }, _ctx.filters, {
                onSummaryExportOptionChanged: _ctx.onExportOptionChanged,
                onDataLoading: _ctx.toggleLoader,
                onDataLoaded: _ctx.toggleLoader
              }), null, 16, ["onSummaryExportOptionChanged", "onDataLoading", "onDataLoaded"]))
            ]),
            revenueAndCommission: _withCtx(() => [
              (_openBlock(), _createBlock(_component_revenue_and_commission_tab, _mergeProps({ key: _ctx.yearAndOptionKey }, _ctx.filters, {
                onRevenueAndCommissionExportOptionChanged: 
              _ctx.onExportOptionChanged
            ,
                onDataLoading: _ctx.toggleLoader,
                onDataLoaded: _ctx.toggleLoader
              }), null, 16, ["onRevenueAndCommissionExportOptionChanged", "onDataLoading", "onDataLoaded"]))
            ]),
            breakdown: _withCtx(() => [
              (_openBlock(), _createBlock(_component_client_manager_breakdown_tab, _mergeProps({ key: _ctx.yearAndClientManagerKey }, _ctx.filters, {
                onBreakdownSalesRepChanged: _ctx.onClientManagerChanged,
                onDataLoading: _ctx.toggleLoader,
                onDataLoaded: _ctx.toggleLoader
              }), null, 16, ["onBreakdownSalesRepChanged", "onDataLoading", "onDataLoaded"]))
            ]),
            clientManagerClients: _withCtx(() => [
              (_openBlock(), _createBlock(_component_client_manager_clients_tab, _mergeProps({ key: _ctx.yearAndClientManagerKey }, _ctx.filters, { onSalesRepClientsSalesRepChanged: _ctx.onClientManagerChanged }), null, 16, ["onSalesRepClientsSalesRepChanged"]))
            ]),
            _: 1
          }, 8, ["selected", "tabs", "onSelect"])
        ]))
      : _createCommentVNode("", true)
  ]))
}